import React, { useState, useEffect } from "react";

import axios from "axios";
import PostAllDataModule from "../../../Components/Reuseable/PostAllDataModule";
import StarPotsNav from "../../../Layouts/Partial/StarPostNav";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const AllPost = () => {
  const [event_data, setEvents] = useState([]);

  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/star/simple_post/all`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.post);
      }
    });
  }, []);

  return (
    <>
      <div className="AS">
        <StarPotsNav />
        {buffer ? (
          <LoaderPost />
        ) : (
          <PostAllDataModule data={event_data} urlLink={`/superstar/post`} />
        )}
      </div>
    </>
  );
};

export default AllPost;
